import { useDispatch } from 'react-redux';

import { NEW_FEATURE_ALERTS } from '@/constants';
import { userPreferencesActions } from '@/store';
import { NewFeatureAlert } from '@/types';

export const enableFeatureReset = (
  dispatch: ReturnType<typeof useDispatch>,
) => {
  if (window.resetFeatureAlert) return;

  window.NEW_FEATURE_ALERTS = NEW_FEATURE_ALERTS;
  window.resetFeatureAlert = (feature: NewFeatureAlert) => {
    dispatch(userPreferencesActions.resetNewFeatureAlert(feature));
    console.log(`Feature alert for ${feature} has been reset.`);
  };
};
